import { Directive, HostListener, Input } from '@angular/core';
import { Store } from '@ngxs/store';
import { ClearNotifications } from '../notification';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: ':not(a):not(area)[routerLink]'
})
export class RouterLinkDirective {
  constructor(private store: Store) {}

  @Input()
  clearNotifications: boolean = true;

  @HostListener('click')
  onClick(): void {
    if (this.clearNotifications) {
      this.store.dispatch(new ClearNotifications());
    }
  }
}
